{
  "ACTIONS": {
    "CONFIRM": "पुष्टि करना",
    "CONTINUE": "जारी रखें",
    "SUBMIT": "जमा करना",
    "RETRY": "पुनः प्रयास करें",
    "CANCEL": "रद्द करना",
    "EMPTY": "आपके पास कोई ऑर्डर नहीं है",
    "LOADING_ORDERS": "आपका बिल तैयार किया जा रहा है",
    "CLEAR_ALL": "सब कुछ हटाएँ",
    "AWESOME": "बहुत बढ़िया",
    "VIEW_RECEIPT": "रसीद",
    "ADD_CART": "कार्ट में जोड़ें",
    "UPDATE_CART": "कार्ट अपडेट करें",
    "EDIT": "संपादित करें",
    "SEARCH_PLACEHOLDER": "भोजन या रेस्तरां खोजें"
  },
  "COMMON": {
    "CALORIES": "कैलोरी {{calories}}",
    "MISSING_SELECTIONS": "कुछ विकल्प गायब हैं कृपया आगे बढ़ने से पहले चयन करें",
    "ITEM_UNAVAILABLE": "यह आइटम फ़िलहाल उपलब्ध नहीं है",
    "SECTION_NOT_FOUND": "यह अनुभाग अब उपलब्ध नहीं है",
    "ITEM_NOT_FOUND": "यह आइटम अब उपलब्ध नहीं है",
    "PROMOTION_NOT_AVAILABLE": "यह प्रमोशन अब उपलब्ध नहीं है",
    "REQUIRED": "आवश्यक",
    "COMBO": "कॉम्बो",
    "INVALID_EMAIL": "कृपया एक मान्य ईमेल पता दर्ज करें",
    "INVALID_PHONE": "कृपया एक मान्य फ़ोन नंबर दर्ज करें",
    "FEES": "शुल्क",
    "MIN_ORDER_ERROR": "अपना ऑर्डर देने के लिए न्यूनतम ऑर्डर मूल्य {{currency}} {{amount}} आवश्यक है",
    "ADD_MIN_ORDER": "अपना ऑर्डर देने के लिए {{currency}} {{amount}} जोड़ें",
    "CONNECTION_ERROR": "इस टेबल को लोड करते समय कुछ गड़बड़ हो गई। कृपया पुनः प्रयास करें।",
    "TABLE_NOT_FOUND": "हमें यह टेबल नहीं मिली। कृपया QR कोड फिर से स्कैन करें।"
  },
  "LANGUAGES": {
    "EN": "English",
    "AR": "عربي",
    "FA": "فارسي",
    "HI": "हिन्दी",
    "RU": "русский",
    "DE": "Deutsch",
    "FR": "Français",
    "TH": "ไทย",
    "EL": "Ελληνικά",
    "CNR": "Crnogorski",
    "ZH-HANS": "中文",
    "RO": "Română",
    "HU": "Magyar",
    "BG": "български",
    "TR": "Türkçe",
    "ES": "Español"
  },
  "BILL": {
    "NAME": "कुलनाम",
    "ROOM_NUMBER": "कमरा नंबर",
    "SNACKBAR_TITLE": "आपका बिल आने वाला है",
    "PAY_BILL": "रुपये की सूची"
  },
  "PAY_AT_TABLE": {
    "TOTAL_PEOPLE": "टेबल पर कुल लोग",
    "PAYING_FOR": "कुल लोग जिनके लिए आप भुगतान कर रहे हैं",
    "REMAINING": "शेष राशि",
    "CHEQUE": "बिल",
    "AMOUNT_PAID": "भुगतान की गई राशि",
    "DISCOUNT": "छूट",
    "PROMO": "प्रोमो",
    "FEES": "शुल्क",
    "PAID_ITEMS": "भुगतान किए गए आइटम",
    "SPLIT_BILL": "बिल बाँटें",
    "EDIT_SPLIT": "बँटवारा संपादित करें",
    "PAY_BILL": "बिल चुकाएँ",
    "SPLIT_TITLE": "बिल बाँटें",
    "SPLIT_SUBTITLE": "चुनें कि आप बिल कैसे बाँटना चाहते हैं",
    "SPLIT_EVENLY": "बराबर बाँटें",
    "CUSTOM_AMOUNT": "कस्टम राशि",
    "ADD_CUSTOM_AMOUNT": "कस्टम राशि जोड़ें",
    "CUSTOM_AMOUNT_PLACEHOLDER": "कस्टम राशि दर्ज करें",
    "PAY_FOR_ITEMS": "अपने आइटम का भुगतान करें",
    "CONFIRM_SELECTION": "चयन की पुष्टि करें",
    "SOMEONE_ELSE_PAYING": "आपकी मेज़ पर कोई और अभी भुगतान कर रहा है"
  },
  "COMBO": {
    "ADD_N": "{{count}} {{section}} जोड़ें",
    "REMOVE_N": "{{count}} {{section}} हटाएँ",
    "CANNOT_PROCEED": "आगे बढ़ने से पहले अपना कॉम्बो पूरा करने के लिए कृपया ऊपर दिए गए निर्देशों का पालन करें",
    "COMPLETE": "{{combo}} कॉम्बो पूरा हुआ!",
    "ON_ANOTHER_SECTION": "यह आपके {{section}} कॉम्बो का हिस्सा है"
  },
  "CART": {
    "TITLE": "कार्ट",
    "RECOMMENDATION": "आपको यह भी पसंद आ सकता है",
    "TOTAL": "कुल",
    "VIEW": "कार्ट देखें और ऑर्डर दें",
    "EMPTY": "खाली",
    "PLACE_ORDER": "अपना आर्डर दें",
    "ADD_TO_BILL": "बिल में जोड़ें",
    "PAY_NOW": "अभी भुगतान करें",
    "OOPS": "उफ़",
    "ADD_NEW_VARIANT": "एक और जोड़ें",
    "VARIANT_TITLE": "क्या आपने अपना मन बदल लिया?",
    "ITEM_UPDATED": "An item in your cart has been updated",
    "ITEM_REMOVED": "An item was removed from your cart because it's no longer available",
    "ITEM_LINE": "{{name}}",
    "CONFIRM_CLEAR": "क्या आप वाकई कार्ट खाली करना चाहते हैं?",
    "CLEAR": "कार्ट को खाली करें",
    "ADD_NOTE": "एक नोट जोड़ें",
    "NOTE_LABEL": "नोट"
  },
  "PAYMENT": {
    "CONFIRMED": "आपके ऑर्डर का भुगतान कर दिया गया है!",
    "ERROR": "भुगतान के दौरान कोई त्रुटि हुई, कृपया पुनः प्रयास करें",
    "APPLE_PAY_TAP_AGAIN": "जारी रखने के लिए कृपया Apple Pay पर फिर से टैप करें",
    "TITLE": "भुगतान",
    "PAY_CARD": "चेक आउट",
    "SUCCESSFUL": "भुगतान सफल रहा",
    "SUMMARY": "बिल सारांश",
    "PROGRESS": "भुगतान प्रगति पर है..., कृपया प्रतीक्षा करें",
    "CANCEL": "कृपया इस पेज को रिफ्रेश न करें या बैक बटन पर क्लिक न करें। यदि आप रद्द करना चाहते हैं, तो कृपया भुगतान मशीन पर रद्द करें बटन दबाएँ।"
  },
  "ORDER": {
    "TITLE": "मेरे फ़रमाईसी सामान",
    "CONFIRMED": "पुष्टि करना",
    "NOTES": "ऑर्डर नोट",
    "TOTAL": "कुल",
    "SUBTOTAL": "उप-योग",
    "ORDER": "फ़रमाईसी सामान",
    "PAID": "चुकाया हुआ",
    "PLACED": "आपका ऑर्डर दे दिया गया है",
    "UNPAID": "आपके ऑर्डर का भुगतान नहीं हुआ है",
    "CANCELLED": "आपका ऑर्डर रद्द कर दिया गया है",
    "VOID": "आपका ऑर्डर निरस्त कर दिया गया है",
    "UPDATED": "आपका ऑर्डर अपडेट कर दिया गया है",
    "ORDERS": "फ़रमाईसी सामान",
    "PREVIOUS": "पिछले ऑर्डर",
    "REJECTED": "ओह! एक या अधिक आइटम या संशोधक वर्तमान में अनुपलब्ध हैं और उन्हें आपके कार्ट से हटा दिया गया है।"
  },
  "WAITER": {
    "SNACKBAR_TITLE": "हम शीघ्र ही आपके साथ होंगे",
    "HELP": "हम कैसे मदद कर सकते हैं?",
    "ADDITIONAL_COMMENTS": "टिप्पणियाँ"
  },
  "MENU": {
    "SKIP": "छोड़ें",
    "MENU": "मेनू",
    "SEARCH": "खोज",
    "NO_SEARCH_RESULTS": "आपकी खोज से मेल खाने वाला कोई आइटम नहीं मिला",
    "SEARCH_OTHER_SECTIONS": "हमें अन्य सेक्शन में मिलते-जुलते आइटम मिले",
    "NO_FILTER_RESULTS": "आपके फ़िल्टर से कोई आइटम मेल नहीं खाता",
    "CLEAR_FILTERS": "फ़िल्टर हटाएँ",
    "NO_SECTIONS": "कोई सेक्शन उपलब्ध नहीं है",
    "STAFF": "स्टाफ को बुलाओ",
    "FILTERS": "आहार फ़िल्टर"
  },
  "SETTINGS": {
    "TITLE": "व्यवस्था",
    "LANGUAGE": "भाषा",
    "SELECT_LANGUAGE": "भाषा चुनें",
    "CURRENCY": "मुद्रा"
  },
  "HOTEL_PREFERENCE": {
    "ROOM": "मेरे कमरे का शुल्क"
  },
  "RESCAN": {
    "TITLE": "क्यू आर ",
    "ACTION": "कृपया अपना सत्र जारी रखने के लिए QR को पुनः स्कैन करें",
    "SESSION_EXPIRED": "आपका सत्र समाप्त हो गया है"
  },
  "PICKUP": {
    "TITLE": "आपका विवरण"
  },
  "VOUCHER": {
    "ADD": "वाउचर जोड़ें",
    "PLACEHOLDER": "अपना वाउचर दर्ज करें",
    "VOUCHER": "वाउचर",
    "DISCOUNTED_AMOUNT": "छूट के बाद कुल",
    "CURRENT_BALANCE": "शेष राशि",
    "REMAINING_BALANCE": "खरीद के बाद शेष राशि",
    "AMOUNT_DUE": "देय राशि"
  },
  "TIP": {
    "TIP": "टिप",
    "ADD": "टिप जोड़ें",
    "PLACEHOLDER": "टिप की राशि दर्ज करें"
  },
  "LANDING": {
    "CALL_WAITER": "वेटर को बुलाएँ",
    "VIEW_BILL": "बिल देखें - ",
    "LOADING_BILL": "बिल लोड हो रहा है"
  },
  "LOADER": {
    "Heading": "आपका भुगतान प्रोसेस किया जा रहा है...",
    "Subheading": "कृपया इस पेज को बंद न करें। हम आपके भुगतान की पुष्टि कर रहे हैं और आपको अपने आप रीडायरेक्ट कर दिया जाएगा।",
    "Hint": "इसमें आमतौर पर कुछ सेकंड लगते हैं।"
  },
  "NoVoucher": "वाउचर उपलब्ध नहीं है",
  "VoucherDisabled": "यह वाउचर निष्क्रिय है",
  "VoucherExpired": "इस वाउचर की अवधि समाप्त हो गई है",
  "VoucherAlreadyUsed": "यह वाउचर पहले ही उपयोग किया जा चुका है",
  "VoucherZeroBalance": "इस वाउचर का बैलेंस 0 है",
  "VoucherUserLimitReached": "आप इस वाउचर का उपयोग पहले ही कर चुके हैं",
  "VoucherFirstOrderOnly": "यह वाउचर केवल आपके पहले ऑर्डर के लिए है",
  "VoucherNotApplicable": "यह वाउचर आपके ऑर्डर में मौजूद वस्तुओं पर लागू नहीं होता"
}
